module.exports = __webpack_public_path__ + "static/media/intro.110af18e.png";